import { loggedIn } from '../../utils/auth'

const state = {
  loggedIn: loggedIn()
}
const mutations = {
  LOGIN (state) {
    state.loggedIn = true
  },
  LOGOUT (state) {
    state.loggedIn = false
  }
}

export default {
  state,
  mutations
}
